import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export function Reveal({ children, delay = 0, className = "", y = 28 }) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.7, delay, ease: EASE }}
        >
            {children}
        </motion.div>
    );
}

export function SectionHead({ label, title, className = "" }) {
    return (
        <div className={className}>
            <Reveal>
                <div className="flex items-center gap-3">
                    <span className="h-px w-8 bg-accent/70" />
                    <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-accent">
                        {label}
                    </span>
                </div>
            </Reveal>
            <Reveal delay={0.08}>
                <h2 className="mt-5 font-display text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">
                    {title}
                </h2>
            </Reveal>
        </div>
    );
}
